import { render, staticRenderFns } from "./OWScrimListPage.vue?vue&type=template&id=8447bc36&scoped=true&"
import script from "./OWScrimListPage.vue?vue&type=script&lang=js&"
export * from "./OWScrimListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8447bc36",
  null
  
)

export default component.exports